<template lang="html">
  <span>
    <a
      class="button-invoices"
      title="Informações de log"
      @click.prevent="openModal"
    >
      <i class="fa fa-info invoice-icon" />
    </a>

    <Modal
      title="Log"
      :is-visible="isVisible"
      :close-modal="closeModal"
      :show-footer="false"
    >
      <table class="table is-striped -is-middle">
        <thead>
          <tr>
            <th>Data</th>
            <th>Evento</th>
            <th>Mensagem</th>
            <th>Detalhes</th>
          </tr>
        </thead>
        <tbody>
          <LogItem
            v-for="(log, index) in reverseLogs"
            :key="index"
            :log="log"
          />
        </tbody>
      </table>
    </Modal>
  </span>
</template>

<script>
import { reverse } from 'lodash';
import { http } from 'app/v1/src/plugins/http';
import { getData } from 'app/v1/src/utils/get';

import LogItem from './Log/Item';
import Modal from 'app/v1/src/components/Modal';

export default {

  components: {
    Modal,
    LogItem,
  },

  props: {
    id: {
      type: String,
      require: true,
      default: ''
    }
  },
  data() {
    return {
      isVisible: false,
      logs: []
    };
  },

  computed: {
    reverseLogs: function() {
      return reverse(this.logs);
    }
  },

  methods: {
    openModal() {
      http.get(`/api/mdfes/${this.id}`)
        .then(getData)
        .then(data => {
          this.logs = data.logs;
          this.isVisible = true;
        })
        .catch(() => Promise.reject('FAIL_IN_FETCH_MDFES'));
    },

    closeModal() {
      this.isVisible = false;
    },
  }
};
</script>
